<!-- 图文-我的发布 -->
<template>
	<div class="wrap">

		<div class="header-wrap">
			<div class="header">
				<img src="../assets/return.png" class="return-img" @click="$router.back()">
				<p class="header-title">我的发布</p>
			</div>

			<div class="search-wrap">
				<div class="search-bar">
					<img src="../assets/search-icon.png" class="search-icon">
					<input type="search" v-model="searchTemp" placeholder="请输入搜索关键字" class="search-input"
						@keydown.enter="submitSearch()" />
				</div>
			</div>
		</div>

    <van-list
        style="width: 100%"
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        :finished-text="list.length > 0 ? '没有更多了' : ''"
        @load="getList"
    >
      <ul class="list">
        <!-- 成功是 success  进行中是ing   失败是fail -->
        <li :class="statusClass[item.status]" v-for="(item, index) in list" :key="index">
          <div class="item-top">
            <div class="img-box">
              <img :src="item.images.toString().split(',')[0]" class="img">
              <span class="item-time">图文</span>
            </div>
            <div class="img-sidebar">
              <p class="item-name">{{ item.title }}</p>
            </div>
            <img src="../assets/icon-39.png" v-if="item.status !== 0" class="icon" @click="currentEdit = item; show = true">
          </div>
          <div class="item-bottom" v-if="item.status === 0">
            <span class="tag">审核中</span>
            <p class="msg">您的稿件审核中</p>
          </div>
          <div class="item-bottom" v-if="item.status === 1">
            <span class="tag">审核成功</span>
            <p class="msg">您的稿件已通过审核</p>
          </div>
          <div class="item-bottom" v-if="item.status === 2">
            <span class="tag">审核失败</span>
            <p class="msg">您的稿件涉嫌洗稿，未通过审核</p>
          </div>
        </li>
        <!-- 无数据时显示 -->
        <div class="normal-box" v-if="list.length === 0">
          <img src="../assets/normal.png">
          暂无数据
        </div>
      </ul>
    </van-list>
		<!-- 弹窗 -->
		<van-popup v-model="show" round position="bottom">
			<div class="window">
				<div class="window-top">
          <button
              type="button"
              class="window-btn"
              @click="show = false; $router.push(`/free-articles?id=${currentEdit.id}`)"
          >
						<img src="../assets/edit-icon.png">编辑
					</button>
					<button type="button" class="window-btn del" @click="del()">
						<img src="../assets/del-icon2.png">删除
					</button>
				</div>
				<div class="window-btn-box">
					<button type="button" @click="show = false">取消</button>
				</div>
			</div>
		</van-popup>

	</div>
</template>

<script>
	// import {
	// 	VideoService
	// } from "@/common/service";
	// import {
	// 	Dialog,
	// 	Toast
	// } from "vant";

  import {ArticleService, DatumService} from "@/common/service";
  import {Dialog, Toast} from "vant";

  export default {
		components: {},
		data() {
			return {
        show: false,
        currentEdit: {},

        statusClass: {
          0: 'ing',
          1: 'success',
          2: 'fail',
        },
        // 搜索关键字
        search: '',
        // 临时搜索关键字
        searchTemp: '',
        params: {
          page: 1,  // 页数
          page_num: 20,  // 每页数
        },
        list: [],
        loading: false,
        finished: false,
			};
		},
    mounted() {
      this.getList();
    },
    methods: {

      getList() {
        this.loading = true;
        ArticleService.getMyArticleList({ title: this.search, ...this.params }).then(({data}) => {
          const list = data.list;
          this.list = this.params.page === 1 ? list : [...this.list, ...list];
          if (list.length < this.params.page_num) {
            this.finished = true;
          } else {
            this.params.page++;
          }
        }).finally(() => {
          this.loading = true;
        });
      },
      submitSearch() {
        this.search = this.searchTemp;
        this.finished = false;
        this.params.page = 1;
        this.getList();
      },
      del() {
        Dialog.confirm({
          title: '确定删除稿件？',
        }).then(() => {
          ArticleService.delUserArticle({id: this.currentEdit.id}).then(({msg}) => {
            this.show = false;
            Toast(msg);
            this.params.page = 1;
            this.finished = false;
            this.getList();
          });
        });
      },

    }
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		min-height: 100vh;
		background-color: #F4F4F4;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 100px 0 0;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header-wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;
	}

	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #F4F4F4;
		position: relative;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.tab-list {
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
		background-color: #FFFFFF;
	}

	.tab-list>li {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 40px;
		line-height: 40px;
		font-size: 16px;
		color: #333333;
		position: relative;
	}

	.tab-list>li.active {
		font-weight: 500;
		color: #222222;
	}

	.tab-list>li.active::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px;
		width: 18px;
		height: 4px;
	}

	.search-wrap {
		width: 100%;
		height: 56px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #FFFFFF;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.search-bar {
		width: 100%;
		height: 36px;
		background-color: #F3F3F3;
		border-radius: 100px;
		display: flex;
		align-items: center;
		padding: 0 10px;
		box-sizing: border-box;
	}

	.search-icon {
		width: 16px;
		margin-right: 10px;
	}

	.search-input {
		flex: 1;
		font-size: 15px;
	}

	.search-input::placeholder {
		color: #B6B6B6;
	}

	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 12px 15px;
		box-sizing: border-box;
	}

	.list>li {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 12px;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		margin-bottom: 12px;
		padding: 0 10px;
		box-sizing: border-box;
	}

	.list>li:last-child {
		margin-bottom: 0;
	}

	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.list>li {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.item-top {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 12px 0;
		border-bottom: 1px solid #F2F2F2;
		box-sizing: border-box;
		position: relative;
	}

	.img-box {
		width: 104px;
		height: 66px;
		border-radius: 12px;
		overflow: hidden;
		position: relative;
		margin-right: 10px;
	}

	.img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.item-time {
		min-width: 34px;
		height: 16px;
		line-height: 16px;
		border-radius: 6px;
		background: rgba(0, 0, 0, 0.8);
		position: absolute;
		right: 8px;
		bottom: 8px;
		color: #FFFFFF;
		font-size: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.img-sidebar {
		flex: 1;
		display: flex;
		flex-direction: column;
		margin-right: 10px;
	}

	.item-name {
		width: 100%;
		line-height: 21px;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #222222;
		font-size: 15px;
	}

	.icon {
		height: 3px;
		position: absolute;
		right: 0;
		bottom: 10px;
	}

	.item-bottom {
		width: 100%;
		height: 53px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 8px 0 3px;
		box-sizing: border-box;
	}

	.tag {
		min-width: 60px;
		height: 20px;
		line-height: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 5px;
		color: #FFFFFF;
		font-size: 12px;
		margin-right: 9px;
	}

	.msg {
		flex: 1;
		height: 26px;
		line-height: 26px;
		display: flex;
		align-items: center;
		padding-left: 25px;
		box-sizing: border-box;
		border-radius: 5px;
		position: relative;
		margin-left: 5px;
	}

	.msg::after {
		content: "";
		width: 0px;
		height: 0px;
		position: absolute;
		left: -5px;
		top: 50%;
		transform: translate(0, -50%);
		border-top: 5px solid transparent;
		border-bottom: 5px solid transparent;

	}

	.list>li.success .tag {
		background-color: #15C393;
	}

	.list>li.success .msg {
		background: #EBF8F3;
		color: #15C393;
	}

	.list>li.success .msg::after {
		border-right: 5px solid #EBF8F3;
	}

	.list>li.ing .tag {
		background-color: #FE9641;
	}

	.list>li.ing .msg {
		background: #FFF4EB;
		color: #FE9641
	}

	.list>li.ing .msg::after {
		border-right: 5px solid #FFF4EB;
	}

	.list>li.fail .tag {
		background-color: #E84537;
	}

	.list>li.fail .msg {
		background: #FCF1EF;
		color: #E84537;
	}

	.list>li.fail .msg::after {
		border-right: 5px solid #FCF1EF;
	}

	.normal-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 14px;
		color: #999992;
		padding: 100px 0;
	}

	.normal-box>img {
		width: 150px;
		margin-bottom: 9px;
	}

	.window {
		width: 100%;
		display: flex;
		flex-direction: column;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 99999999;
		background-color: #FFFFFF;
		border-radius: 16px 16px 0 0;
	}

	.mask-layer {
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		position: fixed;
		left: 0;
		top: 0;
		z-index: 999;
	}

	.window-top {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 30px 25px;
		box-sizing: border-box;
	}

	.window-btn {
		width: 100%;
		display: flex;
		align-items: center;
		color: #222222;
		font-size: 16px;
		margin-bottom: 30px;
	}

	.window-btn:last-child {
		margin-bottom: 0;
	}

	.window-btn.del {
		color: #FF1010;
	}

	.window-btn>img {
		width: 18px;
		margin-right: 20px;
	}

	.window-btn-box {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 15px 38px;
		box-sizing: border-box;
	}

	.window-btn-box>button {
		width: 100%;
		height: 40px;
		line-height: 40px;
		background-color: #F3F3F3;
		border-radius: 100px;
		color: #222222;
		font-size: 16px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>
